import UserApi from './user-api';

class ProvetApi {
    static async getClientEmails(bearerToken, params) {
        console.log('[ProvetApi.getClientEmails] params:', params);
        const res = await UserApi.getProvetClientEmails(bearerToken, params);
        console.log('[ProvetApi.getClientEmails] response:', res);
        return {
            emails: Array.isArray(res?.emails) ? res.emails : [],
            patients: Array.isArray(res?.patients) ? res.patients : [],
        };
    }

    static async addNote(bearerToken, payload) {
        // payload: { clientId, patientId?, handoutTitle, handoutUrl, sentAt, userId, timestamp, verification }
        return UserApi.addProvetNote(bearerToken, payload);
    }
}
export default ProvetApi;
